import { getHeight, getWidth } from './rectPropertyUtils';

export const getArea = (rect) => getWidth(rect) * getHeight(rect);

export const getPerimeter = (rect) => 2 * getWidth(rect) + 2 * getHeight(rect);
